import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/encrypt'

const encrypt = (payload, organization) => AxiosClient.post(
  resource, payload, { headers: { organization } }
)

export {
  encrypt
}
